module.exports = __webpack_public_path__ + "img/General waste.d5767c45.svg";